import * as React from 'react';
import { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { withTheme } from 'styled-components';

import { ConditionalDisclaimers } from '../models/configuration/disclaimers/ConditionalDisclaimers';
import { DisclaimerDisplayType } from '../models/configuration/disclaimers/DisclaimerDisplayType';

import Tooltip from './Tooltip';
import Superscript from './Superscript';

import { DataStore, DisclaimerStore, SuperscriptScope } from '../stores';

export interface InlineDisclaimersProps {
    theme?: any;
    dataStore?: DataStore;
    entityWrapper?: any;
    conditionalDisclaimers: ConditionalDisclaimers;
    superscriptScope: SuperscriptScope;
    superscriptContext?: string;
    accessibilityContext?: string;
    metricContext?: string;
    forceSuperScripts?: boolean;
}

@inject('dataStore')
@observer
class InlineDisclaimers extends Component<InlineDisclaimersProps> {
    loadDisclaimers = (
        callback: (
            disclaimerStore: DisclaimerStore,
            entity: any,
            conditionalDisclaimers: ConditionalDisclaimers
        ) => any,
        defaultValue?: any
    ) => {
        const {
            conditionalDisclaimers,
            dataStore,
            entityWrapper,
            forceSuperScripts,
        } = this.props;

        const entity = entityWrapper && entityWrapper.shareClass;
        if (conditionalDisclaimers && conditionalDisclaimers.length > 0) {
            let updatedConditionalDisclaimers = conditionalDisclaimers;
            if (forceSuperScripts) {
                updatedConditionalDisclaimers = conditionalDisclaimers.map(
                    disclaimer => {
                        return {
                            ...disclaimer,
                            display: DisclaimerDisplayType.superscript,
                        };
                    }
                );
            }
            const disclaimerStore = (dataStore as DataStore).disclaimerStore;
            if (disclaimerStore && callback) {
                return (
                    callback(
                        disclaimerStore,
                        entity,
                        updatedConditionalDisclaimers
                    ) || defaultValue
                );
            }
        }
        return defaultValue;
    };
    loadTooltipDisclaimers(columnContent: any) {
        const { accessibilityContext, metricContext } = this.props;
        return this.loadDisclaimers(
            (disclaimerStore, entity, conditionalDisclaimers) => {
                const tooltipDisclaimers = disclaimerStore.getTooltipDisclaimers(
                    entity,
                    conditionalDisclaimers
                );
                if (tooltipDisclaimers && tooltipDisclaimers.length > 0) {
                    return (
                        <Fragment>
                            {columnContent}
                            <Tooltip
                                content={tooltipDisclaimers}
                                accessibilityContext={accessibilityContext}
                                metricContext={metricContext}
                            />
                        </Fragment>
                    );
                }
            },
            columnContent
        );
    }
    loadDisclaimerSuperscripts(columnContent: any) {
        const { theme, superscriptScope } = this.props;
        return this.loadDisclaimers(
            (disclaimerStore, entity, conditionalDisclaimers) => {
                const superscripts = disclaimerStore.getSuperscripts(
                    entity,
                    conditionalDisclaimers,
                    superscriptScope
                );
                if (superscripts && superscripts.length > 0) {
                    return (
                        <Fragment>
                            {columnContent}
                            <Superscript
                                superscripts={superscripts}
                                superscriptContext={
                                    this.props.superscriptContext
                                }
                                {...theme.Superscript}
                            />
                        </Fragment>
                    );
                }
            },
            columnContent || ''
        );
    }
    render() {
        const { children } = this.props;
        return this.loadTooltipDisclaimers(
            this.loadDisclaimerSuperscripts(children)
        );
    }
}

export default withTheme(InlineDisclaimers);



// WEBPACK FOOTER //
// ./src/Components/InlineDisclaimers.tsx